<template>
    <b-row>
        <b-col cols="9">
            <b-row>
                <b-col class="workspace-header">
                    <div>
                        <b-dropdown split :variant="actionClass" :disabled="disableActions || working"
                                    @click="clickAction"
                                    v-if="actionAvailable" class="mr-3">
                            <template v-slot:button-content v-if="$route.params.status === 'pre-approved'">
                                <i class="fa-solid fa-clipboard-list-check fa-fw"></i> Approve Selected
                            </template>
                            <template v-slot:button-content v-else-if="$route.params.status === 'approved'">
                                <i class="fa-solid fa-clipboard-list-check fa-fw"></i> Process Selected
                            </template>
                            <template v-slot:button-content v-else-if="$route.params.status === 'processed'">
                                <i class="fa-solid fa-clipboard-list-check fa-fw"></i> Fail Selected
                            </template>
                            <b-dropdown-item @click="$refs.listView.voidSelected()" :disabled="disableVoidActions" variant="danger">Void Selected
                            </b-dropdown-item>
                        </b-dropdown>
                        <b-button variant="danger" :disabled="disableActions || working" class="mr-3" v-if="$route.params.status === 'processed'" @click="clickAction">
                            <i class="fa-solid fa-clipboard-list-check fa-fw"></i> {{TextForFailOrFail}} Selected
                        </b-button>
                        <b-button variant="danger" :disabled="disableActions || working" class="mr-3" v-if="$route.params.status === 'failed'" @click="clickAction">
                            <i class="fa-solid fa-clipboard-list-check fa-fw"></i> Clear Selected
                        </b-button>
                        <!--<b-button variant="warning" :disabled="disableActions || working"-->
                                  <!--v-if="$route.params.status === 'processed' && $route.params.method === 'direct-deposit'">-->
                            <!--<i class="fa-regular fa-file-invoice-dollar fa-fa"></i> Download ACH File for Selected-->
                        <!--</b-button>-->
                    </div>
                </b-col>

                <b-col class="workspace-header">
                    <h1 class="text-right"><i class="fa-solid fa-money-bill-alt fa-fw"></i> Payments</h1>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <transition appear name="fade" mode="out-in">
                        <router-view ref="listView" v-on:no-selection="disableActions = $event; handleIsVoidable();"
                                     v-on:working="working = $event" v-on:disableVoidActions="disableVoidActions = $event"></router-view>
                    </transition>
                </b-col>
            </b-row>
        </b-col>

        <b-col cols="3">
            <b-row class="mb-4">
                <b-col>
                    <payments-side-data-widget overview :data="dashboardOverviewData"
                                               icon="fa-light fa-money-check-alt"></payments-side-data-widget>
                    <payments-side-data-widget label="Company Check" :data="dashboardCompanyCheckData"
                                               icon="fa-light fa-money-check-alt"></payments-side-data-widget>
                    <payments-side-data-widget label="Direct Deposit" :data="dashboardDirectDepositData"
                                               icon="fa-light fa-university"></payments-side-data-widget>
                    <payments-side-data-widget label="PayPal" :data="dashboardPaypalData"
                                               icon="fab fa-paypal"></payments-side-data-widget>

                    <b-button block size="lg" :variant="page.primary === 'pre-approved' ? 'primary' : 'light'"
                              :disabled="working"
                              @click="setPageView({primary: 'pre-approved', secondary: null})"><i
                            class="fa-solid fa-layer-plus fa-lg"></i> Pre-Approved
                    </b-button>
                    <b-button-group class="d-flex mb-2">
                        <b-button size="lg"
                                  :variant="page.primary === 'pre-approved' && page.secondary === 'company-check' ? 'primary' : 'secondary'"
                                  :disabled="working"
                                  @click="setPageView({primary: 'pre-approved', secondary: 'company-check'})"><i
                                class="fa-regular fa-money-check-alt"></i></b-button>
                        <b-button size="lg"
                                  :variant="page.primary === 'pre-approved' && page.secondary === 'direct-deposit' ? 'primary' : 'secondary'"
                                  :disabled="working"
                                  @click="setPageView({primary: 'pre-approved', secondary: 'direct-deposit'})"><i
                                class="fa-regular fa-university"></i></b-button>
                        <b-button size="lg"
                                  :variant="page.primary === 'pre-approved' && page.secondary === 'paypal' ? 'primary' : 'secondary'"
                                  :disabled="working"
                                  @click="setPageView({primary: 'pre-approved', secondary: 'paypal'})"><i
                                class="fab fa-paypal"></i></b-button>
                    </b-button-group>

                    <b-button block size="lg" :variant="page.primary === 'approved' ? 'primary' : 'light'"
                              :disabled="working"
                              @click="setPageView({primary: 'approved', secondary: null})"><i
                            class="fa-solid fa-clipboard-list-check fa-lg"></i> Approved
                    </b-button>
                    <b-button-group class="d-flex mb-2">
                        <b-button size="lg"
                                  :variant="page.primary === 'approved' && page.secondary === 'company-check' ? 'primary' : 'secondary'"
                                  :disabled="working"
                                  @click="setPageView({primary: 'approved', secondary: 'company-check'})"><i
                                class="fa-regular fa-money-check-alt"></i></b-button>
                        <b-button size="lg"
                                  :variant="page.primary === 'approved' && page.secondary === 'direct-deposit' ? 'primary' : 'secondary'"
                                  :disabled="working"
                                  @click="setPageView({primary: 'approved', secondary: 'direct-deposit'})"><i
                                class="fa-regular fa-university"></i></b-button>
                        <b-button size="lg"
                                  :variant="page.primary === 'approved' && page.secondary === 'paypal' ? 'primary' : 'secondary'"
                                  :disabled="working"
                                  @click="setPageView({primary: 'approved', secondary: 'paypal'})"><i
                                class="fab fa-paypal"></i></b-button>
                    </b-button-group>

                    <b-button block size="lg" :variant="page.primary === 'processed' ? 'primary' : 'light'"
                              :disabled="working"
                              @click="setPageView({primary: 'processed', secondary: null})"><i
                            class="fa-solid fa-check-circle fa-lg"></i> Processed
                    </b-button>
                    <b-button-group class="d-flex mb-2">
                        <b-button size="lg"
                                  :variant="page.primary === 'processed' && page.secondary === 'company-check' ? 'primary' : 'secondary'"
                                  :disabled="working"
                                  @click="setPageView({primary: 'processed', secondary: 'company-check'})"><i
                                class="fa-regular fa-money-check-alt"></i></b-button>
                        <b-button size="lg"
                                  :variant="page.primary === 'processed' && page.secondary === 'direct-deposit' ? 'primary' : 'secondary'"
                                  :disabled="working"
                                  @click="setPageView({primary: 'processed', secondary: 'direct-deposit'})"><i
                                class="fa-regular fa-university"></i></b-button>
                        <b-button size="lg"
                                  :variant="page.primary === 'processed' && page.secondary === 'paypal' ? 'primary' : 'secondary'"
                                  :disabled="working"
                                  @click="setPageView({primary: 'processed', secondary: 'paypal'})"><i
                                class="fab fa-paypal"></i></b-button>
                    </b-button-group>

                    <b-button block size="lg" :variant="page.primary === 'failed' ? 'primary' : 'light'"
                              :disabled="working"
                              @click="setPageView({primary: 'failed', secondary: null})"><i
                            class="fa-solid fa-exclamation-triangle fa-lg"></i> Failed
                    </b-button>

                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-card header="Reports" class="header-sm " header-bg-variant="dark" body_class="px-0 py-0" no-body>
                        <b-button variant="success" :disabled="currentDownload != false" @click="getReport()"   class="text-xs" size="xss" style="width:100%"><i class="fas" :class="currentDownload == 'report-basic' ? 'fa-spin fa-spinner' :'fa-file-excel'"></i>&nbsp;&nbsp;Export Payments</b-button>
                        <b-button variant="warning" :disabled="currentDownload != false" @click="downloadACH()" class="text-xs" size="xss" style="width:100%"><i class="fas" :class="currentDownload == 'download-ach'? 'fa-spin fa-spinner' :'fa-download'"></i>&nbsp;&nbsp;Download ACH Batch</b-button>
                        <b-button variant="danger"  :disabled="currentDownload != false" @click="uploadACH()"   class="text-xs" size="xss" style="width:100%"><i class="fas" :class="currentDownload == 'upload-ach' ? 'fa-spin fa-spinner' :'fa-upload'"></i>&nbsp;&nbsp;Mark ACH Batch Processed</b-button>
                    </b-card>
                </b-col>
            </b-row>
        </b-col>
        <GenericPopups ref="GenericPopups"></GenericPopups>
    </b-row>
</template>

<script>
    import {
        BROADCAST_CONNECTED,
    } from '../../store/actions';
    import PaymentsSideDataWidget from '@/components/PaymentsSideDataWidget';
    import GenericPopups from "@/components/GenericPopups";

    export default {
        name: 'payments-index',
        title: 'Payments',
        components: {PaymentsSideDataWidget,GenericPopups},
        data() {
            return {
                currentDownload: false,
                dashboardOverviewData: {},
                dashboardCompanyCheckData: {},
                dashboardDirectDepositData: {},
                dashboardPaypalData: {},
                page: {
                    primary: 'pre-approved',
                    secondary: null,
                },
                disableActions: true,
                disableVoidActions: true,
                TextForFailOrFail: 'Fail',
                working: false,
            };
        },
        created() {
            this.page.primary = this.$route.params.status;
            this.page.secondary = this.$route.params.method;

            this.$http.get('/dashboards/payments')
                .then(response => {
                    this.dashboardOverviewData = response.data.data.overview;
                    this.dashboardCompanyCheckData = response.data.data.company_check;
                    this.dashboardDirectDepositData = response.data.data.direct_deposit;
                    this.dashboardPaypalData = response.data.data.paypal;
                });
        },
        mounted() {
            console.info(String.fromCodePoint(0x1F6F0) + '%c Broadcast Connected:', 'color:yellow;', this.$store.getters.isBroadcastConnected);
            if (! this.$store.getters.isBroadcastConnected) {
                this.$store.subscribe((mutation) => {
                    console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                    if (mutation.type === BROADCAST_CONNECTED) {
                        console.info(String.fromCodePoint(0x1F504) + '%c Joining via BROADCAST_CONNECTED mutation.', 'color:green;');
                        this.joinBroadcastChannel();
                    }
                });
            } else {
                console.info(String.fromCodePoint(0x2757) + '%c Joining via isBroadcastConnected getter.', 'color:teal;');
                this.joinBroadcastChannel();
            }
        },
        beforeDestroy() {
            console.info(String.fromCodePoint(0x1F44B) + ' Leaving App.Payments channel from Payments/index.vue.');
            this.$echo.leaveChannel('App.Payments');
        },
        methods: {
            joinBroadcastChannel: function () {
                console.info(String.fromCodePoint(0x1F91D) + ' Joining App.Payments channel from Payments/index.vue.');
                this.$echo.channel('App.Payments').listen('PaymentWasProcessed', (e) => {
                    // TODO: Consider refactoring to functions that smartly handle this logic to re-use for other listeners
                    this.dashboardOverviewData.total -= 1;
                    this.dashboardOverviewData.total_amount -= e.payment.amount;
                    switch (e.payment.payment_method) {
                        case 'company-check':
                            this.dashboardOverviewData.company_check -= 1;
                            this.dashboardCompanyCheckData.outstanding -= 1;
                            this.dashboardCompanyCheckData.processed += 1;
                            break;
                        case 'direct-deposit':
                            this.dashboardOverviewData.direct_deposit -= 1;
                            this.dashboardDirectDepositData.outstanding -= 1;
                            this.dashboardDirectDepositData.processed += 1;
                            break;
                        case 'paypal':
                            this.dashboardOverviewData.paypal -= 1;
                            this.dashboardPaypalData.outstanding -= 1;
                            this.dashboardPaypalData.processed += 1;
                            break;
                    }
                }).listen('PaymentWasVoided', (e) => {
                    if (e.payment.processed_at == null) {
                        this.dashboardOverviewData.total -= 1;
                        this.dashboardOverviewData.total_amount -= e.payment.amount;
                    }
                    switch (e.payment.payment_method) {
                        case 'company-check':
                            this.dashboardCompanyCheckData.total -= 1;
                            this.dashboardCompanyCheckData.total_amount -= e.payment.amount;
                            if (e.payment.processed_at == null) {
                                this.dashboardOverviewData.company_check -= 1;
                                this.dashboardCompanyCheckData.outstanding -= 1;
                            } else {
                                this.dashboardCompanyCheckData.processed -= 1;
                            }
                            break;
                        case 'direct-deposit':
                            this.dashboardDirectDepositData.total -= 1;
                            this.dashboardDirectDepositData.total_amount -= e.payment.amount;
                            if (e.payment.processed_at == null) {
                                this.dashboardOverviewData.direct_deposit -= 1;
                                this.dashboardDirectDepositData.outstanding -= 1;
                            } else {
                                this.dashboardDirectDepositData.processed -= 1;
                            }
                            break;
                        case 'paypal':
                            this.dashboardPaypalData.total -= 1;
                            this.dashboardPaypalData.total_amount -= e.payment.amount;
                            if (e.payment.processed_at == null) {
                                this.dashboardOverviewData.paypal -= 1;
                                this.dashboardPaypalData.outstanding -= 1;
                            } else {
                                this.dashboardPaypalData.processed -= 1;
                            }
                            break;
                    }
                }).listen('PaymentWasFailed',  (e) => {
                    this.dashboardOverviewData.failed += 1;
                    if (e.payment.processed_at == null) {
                        this.dashboardOverviewData.total -= 1;
                        this.dashboardOverviewData.total_amount -= e.payment.amount;
                    }
                    switch (e.payment.payment_method) {
                        case 'company-check':
                            this.dashboardCompanyCheckData.total -= 1;
                            this.dashboardCompanyCheckData.total_amount -= e.payment.amount;
                            if (e.payment.processed_at == null) {
                                this.dashboardOverviewData.company_check -= 1;
                                this.dashboardCompanyCheckData.outstanding -= 1;
                            } else {
                                this.dashboardCompanyCheckData.processed -= 1;
                            }
                            break;
                        case 'direct-deposit':
                            this.dashboardDirectDepositData.total -= 1;
                            this.dashboardDirectDepositData.total_amount -= e.payment.amount;
                            if (e.payment.processed_at == null) {
                                this.dashboardOverviewData.direct_deposit -= 1;
                                this.dashboardDirectDepositData.outstanding -= 1;
                            } else {
                                this.dashboardDirectDepositData.processed -= 1;
                            }
                            break;
                        case 'paypal':
                            this.dashboardPaypalData.total -= 1;
                            this.dashboardPaypalData.total_amount -= e.payment.amount;
                            if (e.payment.processed_at == null) {
                                this.dashboardOverviewData.paypal -= 1;
                                this.dashboardPaypalData.outstanding -= 1;
                            } else {
                                this.dashboardPaypalData.processed -= 1;
                            }
                            break;
                    }
                }).listen('PaymentWasCreated', (e) => {
                    this.dashboardOverviewData.total += 1;
                    this.dashboardOverviewData.total_amount += e.payment.amount;
                    switch (e.payment.payment_method) {
                        case 'company-check':
                            this.dashboardOverviewData.company_check += 1;
                            this.dashboardCompanyCheckData.outstanding += 1;
                            this.dashboardCompanyCheckData.total += 1;
                            this.dashboardCompanyCheckData.total_amount += e.payment.amount;
                            break;
                        case 'direct-deposit':
                            this.dashboardOverviewData.direct_deposit += 1;
                            this.dashboardDirectDepositData.outstanding += 1;
                            this.dashboardDirectDepositData.total += 1;
                            this.dashboardDirectDepositData.total_amount += e.payment.amount;
                            break;
                        case 'paypal':
                            this.dashboardOverviewData.paypal += 1;
                            this.dashboardPaypalData.outstanding += 1;
                            this.dashboardPaypalData.total += 1;
                            this.dashboardPaypalData.total_amount += e.payment.amount;
                            break;
                    }
                })
                .listen('PaymentWasUpdated', (e) => {
                    // TODO: Handle the changes in status, payment-method
                });
                // TODO: Listen for created, failedz
            },
            getReport(){
                this.currentDownload = 'report-basic';
                this.$refs.listView.getReport(()=>{
                    this.currentDownload = false;
                });
            },
            downloadACH(){
                //do something, idk
                this.currentDownload = 'download-ach';
                let url = '/createNACHA';
                this.$http.post(url).then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));

                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;

                    fileLink.setAttribute('download', 'ACH_Report-' + Date.now() + '.txt');

                    document.body.appendChild(fileLink);

                        fileLink.click();
                }).finally((e) => {
                    this.currentDownload = false;
                });
            },
            uploadACH(){

                this.$refs.GenericPopups.displayPermission =
                    {
                        title: 'Process ACH?',
                        text: 'Are you sure you want to mark ACH as Processed?',
                        ok: 'Complete ACH', //manager override will do function
                        cancel: 'Cancel', //cancel is a 'ok'
                        permission: 'manage payments',
                        okAction: () => {
                            this.currentDownload = 'upload-ach';
                            let url = '/payments/MarkACHProcessesed';
                            this.$http.post(url).then((response) => {
                                this.currentDownload = false;
                                let payment = response.data.data;
                                console.log(payment);
                                let locked_ids = _.filter(payment, payment => payment.status == 'approved').map(payment => payment.order.id);
                                if (locked_ids.length > 0) {
                                    let message = "The following orders have a stop workflow and were not set to processed, " + locked_ids.join(", ") + ''
                                    this.$bvModal.msgBoxOk(message, {
                                        title: 'Issue with Processing Offers',
                                        size: 'md',
                                        okTitle: 'Yes',
                                        buttonSize: 'sm',
                                        okVariant: 'danger',
                                        cancelVariant: 'secondary',
                                        headerClass: 'p-2 border-bottom-0 text-center d-block',
                                        footerClass: 'p-2 border-top-0',
                                    });
                                }
                                //refresh view correctly
                                this.$refs.listView.getData();
                            });
                        },
                        endPointsLater: ['/payments/MarkACHProcessesed']
                    };
            },
            setPageView(destination) {
                this.page.primary = destination.primary;
                this.page.secondary = destination.secondary;
                let path = '/payments/' + destination.primary;
                if (destination.secondary) {
                    path = path + '/' + destination.secondary;
                }
                this.$router.push({path: path});
                this.$refs.listView.getData();
            },
            clickAction() {
                if (this.$route.params.status === 'pre-approved') {
                    this.$refs.listView.approveSelected();
                } else if (this.$route.params.status === 'processed') {
                    this.$refs.listView.failSelected();
                } else if (this.$route.params.status === 'approved') {
                    this.$refs.listView.processSelected();
                } else if(this.$route.params.status === 'failed') {
                    this.$refs.listView.clearSelectedItems();
                }
            },
            handleIsVoidable(){
                if(this.$refs.listView.selectedContainsVoidOnly()){
                    if(this.$refs.listView.selectContainsFailOnly()){
                        this.TextForFailOrFail = "Fail/Void";
                    } else {
                        this.TextForFailOrFail = "Void";
                    }
                } else if(this.$refs.listView.selectContainsFailOnly()){
                    this.TextForFailOrFail = "Fail";
                } else if (this.$route.params.method === 'company-check'){ //no selected items company check
                    this.TextForFailOrFail = "Void";
                }
                else{ //no selected items, anything else.
                    this.TextForFailOrFail = "Fail";
                }
            },
        },
        computed: {
            actionAvailable() {
                return this.$route.params.status === 'pre-approved' || this.$route.params.status === 'approved';
            },
            actionClass() {
                if (this.$route.params.status === 'approved') {
                    return 'success';
                } else if (this.$route.params.status === 'processed') {
                    return 'danger';
                } else {
                    return 'primary';
                }
            },
        },
        watch: {
            $route() {
                this.page.primary = this.$route.params.status;
                this.page.secondary = this.$route.params.method;
                this.handleIsVoidable();
            },
        },
    };
</script>

<style scoped>

</style>
